module.exports = __webpack_public_path__ + "img/safe.51cb1fc0.png";